export default "__VITE_ASSET__BXMAl6e3__"